import type { AlertBannerVariants } from '@/components/molecules/alert-banner/alert-banner';

const variables = {
  noteTextAlertBanner: {
    variant: 'neutral' as AlertBannerVariants,
  },
};

export default variables;
